import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from '../../../../../../../projects/Administration/src/app/business-entities/brand.model';
import { RentalCarService } from '../../../../../../../projects/Administration/src/app/business-services/rental-car.service';
import { ImageService } from '../../../../../../../projects/Administration/src/app/services/image.service';
import { CurrentLanguage } from '../../../../../../../projects/Autofacets-Core/src/app/common-services/current-language.service';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model'
import { Constant } from '../../../../../../../projects/Autofacets-Core/src/app/utils/constant';
import { CheckListBusinessService } from '../../../../../../../projects/Administration/src/app/business-services/check-list.service';
import { AddPromotionModel } from '../../../business-entities/promotions-model';
import { PromotionBusinessService } from '../../../business-services/promotion.service';
import { CategoryService } from '../../../business-services/category.service';
import { Categories } from '../../../business-entities/category-list-model';
import { CookieService } from 'ngx-cookie-service';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerHolidayBusinessService } from '../../../business-services/dealer-holiday.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-add-promotions',
  templateUrl: './add-promotions.component.html'
 
})
export class AddPromotionsComponent implements OnInit {
    promotion: AddPromotionModel =
    {
      id: 0,
      brandId: null,
      categoryId: null,
      promotionNames: "",
      categoryNames: "",
      promotionDescription:"",
      enpromotionNames: "",
      depromotionNames: "",
      nlpromotionNames: "",
      encategoryNames: "",
      decategoryNames: "",
      nlcategoryNames: "",
      createdBy: "",
      imageBinaryData: "", 
      mimeType: "",
      image: "",
      promotionImage: "",
      languageCode: "",
      originalPrice: null,
      startDate: null,
      endDate: null,
      isMultipleAllowed: false,
      quantity: null,
      offerPrice: null,
      offerStartDate: null,
      offerEndDate: null
    };
    dealerList: SelectListItemViewModel[];
    selectedDealer:any[]=[];
    selectedDealerId: string;
    dealerId: string;
    dealerSelected: {value:string, text:string}[] = [];
    startDate: string;
    endDate: string;
    offerStartDate: string;
    offerEndDate: string;
  isMaxAnswer: boolean = false
  answers: string
  addPreference = false;
  AnswerList = Array(1);
  addPromotionsForm: FormGroup;
  brandList: Brand[] = [];
  categoryList: Categories[] = [];
  brand: Brand[];
  isValidDate = true;
  imageBaseData: string | ArrayBuffer = null;
  allLanguage: any[];
  vehicleTypes: VehicleType[] = [];
  dropdownSettings: {};
  constructor(
    private formBuilder: FormBuilder,
    private getAllCategories: CategoryService,
    private getAllBrandData: RentalCarService,
    public dealerHolidayBusinessService: DealerHolidayBusinessService,
    private promotionService: PromotionBusinessService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private imageService: ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.getCategories();
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.addPromotionsForm = this.formBuilder.group({
      brand: [null, [Validators.required]],
      category: [null, [Validators.required]],
      dealer: ['', [Validators.required]],
      promotionDescription: new FormArray([]),
      promotionNames: new FormArray([]),
      categoryNames: new FormArray([]),
      startDate: [''],
      endDate: [''],
      originalPrice: [''],
      offerStartDate: [''],
      offerEndDate: [''],
      offerPrice: [''],
      isAllowedMultiple: [false],
      quantity: [''],
      image: [''],
      isActive: [true]
    });
    this.getBrandData();
    this.getdealerList();
    this.getLanguageP();
    this.GetAllVehicleTypes();
    this.dropdownSettings = {
        singleSelection: false,
        idField: 'value',
        textField: 'text',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 5,
        allowSearchFilter: true,
        searchPlaceholderText: 'Search here',
        maxHeight: 500
      };
  }

  formatter = (result: SelectListItemViewModel) => result.text.toUpperCase();

  convertDate(d: any) {
    let parts = d.split(" ");
    let months = { Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06", Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12" };
    return parts[3] + "-" + months[parts[1]] + "-" + parts[2];
}

validateDates(sDate: string, eDate: string) {
    if (sDate == null || eDate == null) {
        this.toaster.error(Constant.DateValidation);
        return !this.isValidDate;
    }

    if (eDate < sDate) {
        this.toaster.error(Constant.DateRangeValidation);
        return !this.isValidDate;
    }
    return this.isValidDate;
}

validateDateTime(startDate:Date,endDate:Date)
{
    if(endDate<startDate)
    {
        this.toaster.error(Constant.DateRangeValidation);
        return !this.isValidDate;
    }
    return this.isValidDate;
}

  get p() { return this.cpf.promotionNames as FormArray; }

  get c() { return this.cpf.categoryNames as FormArray; }
  get t() { return this.cpf.promotionDescription as FormArray; }

  async getdealerList() {
    this.dealerList = this.dealerHolidayBusinessService.dealerList;
    }

  getLanguageP() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.p.length < number) {
      for (let i = this.p.length; i < number; i++) {
        this.p.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.p.length; i >= number; i--) {
        this.p.removeAt(i);
      }
    }
    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }

    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }



  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if (localStorage.getItem("Theme") == Constant.BnhInterface) {
        this.vehicleTypes = data.responseObject;
      }
      else {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }

  async getBrandData() {
    await this.GetAllBrand();
  }
  get cpf() {
    return this.addPromotionsForm.controls;
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.promotion.mimeType = files[0].type;
    this.promotion.image = files[0].name;
    this.promotion.promotionImage = "";
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormate = this.imageService.validateImageFormat(this.promotion.mimeType);
    if (isValidFormate) {
      reader.onload = (_readerEvent) => {
        me.imageBaseData = reader.result;
        this.promotion.imageBinaryData = reader.result.toString().replace('data:' + this.promotion.mimeType + ';base64,', '');
        this.promotion.promotionImage = me.imageBaseData;
      };
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }
    reader.onerror = function (_error) {
      // This is intentional
    };
    this.spinner.hide();

  }
  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  async getCategories(){
    let language = this.cookieservice.get('userSelectedLanguage')
    let requestObj =
    {
      LANGUAGECODE: language
    }
    await this.getAllCategories.getCategoryList(requestObj).then((response) => {
      this.categoryList = this.mapCategory(response);
      this.getAllCategories.categoryList = this.categoryList;
    })
  }

  async setDealerDetails() {
    let selectedDealerId = this.dealerHolidayBusinessService.dealerId;
    if (selectedDealerId && selectedDealerId !== '') {
         await this.onDropdownDealerSelected(selectedDealerId)
    }
    }

  onDropdownDealerSelected(dealerId: any): void {
    if (dealerId == null) {
      this.selectedDealer = [];
      this.selectedDealerId='';
    } else {
      if (dealerId.length == 0) {
        this.selectedDealer= [];
        this.selectedDealerId=''
      }
      else
      {
        let dealerIdValue='';
        dealerId.forEach(element => {
            dealerIdValue +=element.value + ','
        });
        this.selectedDealerId=dealerIdValue;
      }
    }
  }
  mapCategory(array: Categories[]){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{
        let single = Object();
        single.id = element.id
        single.name = element.categoryName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  addPromotions() {
    this.spinner.show();
    let endDate = (this.addPromotionsForm.value.endDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addPromotionsForm.value.endDate)):null;
    let startDate = (this.addPromotionsForm.value.startDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addPromotionsForm.value.startDate)):null;
    let offerEndDate = (this.addPromotionsForm.value.offerEndDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addPromotionsForm.value.offerEndDate)):null;
    let offerStartDate = (this.addPromotionsForm.value.offerStartDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addPromotionsForm.value.offerStartDate)):null;
    let currentUser = this.userService.currentUserValue.id;
    const viewModel = {
      ...this.addPromotionsForm.value,
      endDate: endDate,
      startDate: startDate,
      dealerList: this.dealerSelected,
      categoryId: this.categoryList.find(m => m.id === this.addPromotionsForm.get('category').value).id,
      image: this.promotion.image,
      mimeType: this.promotion.mimeType,
      imageBinaryData: this.promotion.imageBinaryData,
      createdBy: currentUser,
      offerEndDate: offerEndDate,
      offerStartDate: offerStartDate,
    }
    const isValidFormat = this.imageService.validateImageFormat(this.promotion.mimeType);
    if (isValidFormat) {
      this.promotionService.addEditPromotion(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.spinner.hide();
          this.router.navigate(['promotions']);
          let successMsg = this.translate.instant("lblPromotionAdded");
          this.toaster.success(successMsg);
          this.activeModal.close({ success: true });
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          let errorErr = this.translate.instant("lblPromotionExists");
          this.toaster.warning(errorErr);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }
    this.spinner.hide();
  }
  OnClose() {
    this.activeModal.close({success:false})
  }
}
